module.exports = __webpack_public_path__ + "img/nutrition.39e3a923.jpg";